const routes = [
  {
    index: true,
    label: 'Benjamin Loo',
    path: '/',
    key: 'home',
  },
  {
    label: 'About',
    path: '/about',
    key: 'about',
  },
  {
    label: 'Resume',
    path: '/resume',
    key: 'resume',
  },
  {
    label: 'Projects',
    path: '/projects',
    key: 'projects',
  },
  {
    label: 'Stats',
    path: '/stats',
    key: 'stats',
  },
  {
    label: 'Contact',
    path: '/contact',
    key: 'contact',
  },
];

export default routes;
